import { scrollToElement } from "../../helpers";

export default function () {
    $(".js-scroll-to-button").on("click", function () {
        scrollToElement($(this));
    });
}
